export const fireBaseConfig = {
  apiKey: "AIzaSyDaLxlCfX6-TyQq5-ICkYHVIocqrtEe1EI",
  authDomain: "stretcherbearerrefresh.firebaseapp.com",
  projectId: "stretcherbearerrefresh",
  storageBucket: "stretcherbearerrefresh.appspot.com",
  messagingSenderId: "351236378627",
  appId: "1:351236378627:web:1d695794f00fbf080a3e36",
  measurementId: "G-CM5WEJTGYH",
};
